import { Helmet } from 'react-helmet-async';

export const WindowTitle = () => (
  <Helmet
    link={[
      {
        rel: 'shortcut icon',
        href: `/favicon/${process.env.BRAND}/favicon.ico`,
      },
    ]}
  />
);
